/** @jsx jsx */
import { forwardRef, memo } from 'react';
import { jsx } from '@emotion/react';
import BaseTag from '../shared/base';
import Before from '../shared/before';
import Content from '../shared/content';
var SimpleTag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var appearance = _ref.appearance,
    _ref$elemBefore = _ref.elemBefore,
    elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'standard' : _ref$color,
    href = _ref.href,
    testId = _ref.testId,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    linkComponent = _ref.linkComponent;
  var content = jsx(Content, {
    elemBefore: elemBefore,
    isRemovable: false,
    text: text,
    color: color,
    href: href,
    linkComponent: linkComponent
  });
  return jsx(BaseTag, {
    ref: ref,
    testId: testId,
    href: href,
    appearance: appearance,
    color: color,
    before: jsx(Before, {
      elemBefore: elemBefore
    }),
    contentElement: content
  });
});
export default /*#__PURE__*/memo(SimpleTag);